import { PutCommand } from "@aws-sdk/lib-dynamodb";
import { ddbDocClient } from "./ddbDocClient";

export async function PushResultsToDynamoDB(props) {
  const params = {
    TableName: "decorator_results",
    Item: {
      guid: props.guid,
      guessMode: props.parameters.guessMode,
      ddimSteps: props.parameters.ddimSteps,
      seed: props.parameters.seed,
      strength: props.parameters.strength,
      valueThreshold: props.parameters.valueThreshold,
      imageResolution: props.parameters.imageResolution,
      detectResolution: props.parameters.detectResolution,
      distanceThreshold: props.parameters.distanceThreshold,
      scale: props.parameters.scale,
      eta: props.parameters.eta,
      a_prompt: props.hardPrompts.a_prompt,
      n_prompt: props.hardPrompts.n_prompt,
      prompt: props.prompt.prompt,
      rating: props.rating,
      feedback: props.feedback,
    },
  };
  console.log(JSON.stringify(props));
  // const command = new PutObjectCommand(params);

  try {
    const data = await ddbDocClient.send(new PutCommand(params));
    console.log("Success:", data);
    return data;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
}
